import * as React from 'react';
type IconTestExportadorProps = React.SVGProps<SVGSVGElement>;

export const IconTestExportador: React.FC<IconTestExportadorProps> = (props) => (
	<svg
	width={25} height={32} viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<rect x="2" y="2" width="23" height="30" rx="2" fill="#FFA692"/>
<rect width="23" height="30" rx="2" fill="#EBF8F0"/>
<path d="M3.5 6.22222L5.34615 8L9.5 4" stroke="#7EAE90" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.5 15.2222L5.34615 17L9.5 13" stroke="#7EAE90" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="6" cy="24.5" r="2.5" fill="#7EAE90"/>
</svg>



);
export default IconTestExportador;
